import { MprcReorderList, MprcRequestErrorReport, MprcRequestIndicator, MprcSpinnerIndicator, ReorderListItem } from 'components';
import { ButtonCancel, ButtonSave } from 'components/buttons';
import { MprcSimpleDialog } from 'components/MprcSimpleDialog';
import LibUtils from 'lib/LibUtils';
import { enqueueSnackbar } from 'notistack';
import { useCoreApi } from 'providers/CoreApiProvider';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

////////////////////////////////////////////////////////////////////////////

interface IProps {
    devPlanGroupId: string;
    onClose: (success?: boolean) => void;
    subtitle?: string;
}

////////////////////////////////////////////////////////////////////////////

export const DevPlanReorderItemsDialog: React.FC<IProps> = ({ devPlanGroupId, subtitle, onClose }) => {

    const api = useCoreApi();
    const { t } = useTranslation("lms");

    const [loading, setLoading] = useState<boolean>(true);
    const [saving, setSaving] = useState<boolean>(false);
    const [itemsInOrder, setItemsInOrder] = useState<ReorderListItem[]>([]);
    const [viewError, setViewError] = useState<any>();

    const previousItemsData = useRef<ReorderListItem[]>([]);

    const canSave = !loading && !saving && !LibUtils.deepCompare(previousItemsData.current, itemsInOrder);

    useEffect(() => {
        setLoading(true);
        api.v1.devPlan.devPlanItems({ devPlanGroupId })
            .then(response => {
                var items = response.data.map(p => ({ id: p.devPlanItemId, text: p.title }));

                previousItemsData.current = items;
                setItemsInOrder(items);
            })
            .catch(e => setViewError(e))
            .finally(() => setLoading(false));
    }, []);

    ///
    const handleSave = () => {
        setSaving(true);
        api.v1.devPlan.reorderItems({ devPlanGroupId, itemsInOrder: itemsInOrder.map(p => p.id) })
            .then(response => {
                if (response.data === true) {
                    enqueueSnackbar(t("Record.SaveSuccessMessage", { ns: "shared" }), { variant: "success" });
                    onClose(true);
                }
                else {
                    enqueueSnackbar(t("Record.FailSuccessMessage", { ns: "shared" }), { variant: "error" });
                }
            })
            .catch(e => setViewError(e))
            .finally(() => setSaving(false));
    };


    return (
        <MprcSimpleDialog
            title={t("DevPlan.DevPlanItemsReorderDialog.Title")}
            subtitle={subtitle}
            width="sm"
            message={
                <>
                    {viewError ?
                        <MprcRequestErrorReport error={viewError} />
                        :
                        <>
                            <MprcRequestIndicator type="post" visible={saving} />
                            {loading
                                ? <MprcSpinnerIndicator />
                                : <MprcReorderList
                                    items={itemsInOrder}
                                    onChangeOrder={(items) => setItemsInOrder(items)}
                                />
                            }
                        </>
                    }
                </>
            }
            onClose={onClose}
            actionsPosition="end"
            actions={
                <>
                    <ButtonCancel onClick={() => onClose()} />
                    <ButtonSave disabled={!canSave} onClick={handleSave} />
                </>
            }
        />
    );
};
